export const ROUTE_APP_HOME = "/home";
export const ROUTE_APP_LOGIN = "/";
